import { render, staticRenderFns } from "./RelatorData.vue?vue&type=template&id=303acf10&"
import script from "./RelatorData.vue?vue&type=script&lang=js&"
export * from "./RelatorData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports